// ----------------------------------------------------------------------

/**
 * Layer for the sidesheets mounted at the app root by `modal-container` — the mailer, the task
 * viewer and the task editor. They are not children of whatever surface launched them, so they need
 * a layer chosen against MUI's scale rather than the surrounding component's.
 *
 * 1350 puts them above `zIndex.modal` (1300), which clears both the quick-view drawer
 * (`zIndex.drawer`, 1200) and the centred record overlay `Dialog` — before JT1-1583 the mailer sat
 * at 1000 and opened *behind* the quick view. It stays below `snackbar` (1400) and `tooltip` (1500)
 * so notifications and tooltips still surface over an open sidesheet.
 *
 * Anything raised to this layer must also carry `data-app-sidesheet`, which is how the record panel
 * knows to leave Esc and the arrow keys alone (see `record-panel-frame.tsx`).
 */
export const APP_SIDESHEET_Z_INDEX = 1350;

/**
 * Layer for anything portaled *out of* a sidesheet — a popper, a menu, an Autocomplete listbox.
 *
 * MUI pins `Autocomplete`'s popper to `theme.zIndex.modal` (1300) in its own styles, and only the
 * paper/listbox are themeable here, not the popper. A sidesheet at 1350 in the same root stacking
 * context therefore paints straight over it: the options are in the DOM and invisible, which read as
 * "the template list is empty" in the mailer (JT1-1725). Stays below `snackbar` (1400).
 */
export const APP_SIDESHEET_POPPER_Z_INDEX = APP_SIDESHEET_Z_INDEX + 1;
